import React, { useEffect, useState, useMemo } from 'react'
import DashboardTodaysDeviceStatus from './DashboardTodaysDeviceStatus';
import { DASHBOARD_INTERVAL_TIMER } from '../../config';

const DashboardTodaysAlertStatus = ({
  SiteName,
  handleModalShow,
  siteId,
  getcsvFileName,
  widget,
  deviceStatus,
  alertsData
}) => {
  // Flatten alertsData if it's an object with keys (as in your API response)
  const flatAlertsData = useMemo(() => (
    Array.isArray(alertsData)
      ? alertsData
      : alertsData && typeof alertsData === 'object'
        ? Object.values(alertsData).flat()
        : []
  ), [alertsData]);

  // Default severities
  const defaultSeverities = [
    { SeverityTitle: "Extreme", OpenCount: 0, CloseCount: 0, AckCount: 0 },
    { SeverityTitle: "High", OpenCount: 0, CloseCount: 0, AckCount: 0 },
    { SeverityTitle: "Moderate", OpenCount: 0, CloseCount: 0, AckCount: 0 },
    { SeverityTitle: "Low", OpenCount: 0, CloseCount: 0, AckCount: 0 },
  ];

  const [severityData, setSeverityData] = useState(defaultSeverities);

  // Parse alertsData for WidgetID 15
  useEffect(() => {
    const widget15 = flatAlertsData.find(w => w.WidgetID === 15 && w.WidgetData);
    if (!widget15 || !widget15.WidgetData) {
      setSeverityData(defaultSeverities);
      return;
    }
    const data = widget15.WidgetData;
    const severities = defaultSeverities.map(sev => {
      const sevData = data[sev.SeverityTitle] || {};
      return {
        SeverityTitle: sev.SeverityTitle,
        OpenCount: sevData.Open || 0,
        CloseCount: sevData.Closed || 0,
        AckCount: sevData.Acknowledged || 0,
      };
    });
    setSeverityData(severities);
  }, [flatAlertsData]);

  const severityClasses = {
    Extreme: "extreme",
    High: "high",
    Moderate: "moderate",
    Low: "low",
  };

  return (
    <div className='TodayAlertDiv'>
      <h5>Today's</h5>
      <hr />
      <div>
        <h6>Alerts</h6>
          <div className="Alertcontainer">
            {severityData.map((alert, index) => (
              <div className={`box ${severityClasses[alert.SeverityTitle]}`} key={index}>
                <div className="title">{alert.SeverityTitle}</div>
                <div className="content">
                  <div className="column">
                    <span>Open</span>
                    <h6 style={{ cursor: handleModalShow ? 'pointer' : 'default' }}
                      onClick={() => handleModalShow({ AlertStatus: "Open", Severity: alert.SeverityTitle }, "Alert", 1, { SiteID: [siteId] }, getcsvFileName('Alert', 'Open'), alert.SeverityTitle)}>{alert.OpenCount}</h6>
                  </div>
                  <div className="column">
                    <span>Close</span>
                    <h6 style={{ cursor: handleModalShow ? 'pointer' : 'default' }}
                      onClick={() => handleModalShow({ AlertStatus: "Closed", Severity: alert.SeverityTitle }, "Alert", 1, { SiteID: [siteId] }, getcsvFileName('Alert', 'Closed'), alert.SeverityTitle)}>{alert.CloseCount}</h6>
                  </div>
                  <div className="column">
                    <span>Ack</span>
                    <h6 style={{ cursor: handleModalShow ? 'pointer' : 'default' }}
                      onClick={() => handleModalShow({ AlertStatus: "Acknowledged", Severity: alert.SeverityTitle }, "Alert", 1, { SiteID: [siteId] }, getcsvFileName('Alert', 'Acknowledged'), alert.SeverityTitle)}>{alert.AckCount}</h6>
                  </div>
                </div>
              </div>
            ))}
          </div>
      </div>

      <div className='mt-3'>
        <h6>Device Status</h6>
        <DashboardTodaysDeviceStatus SiteName={SiteName} handleModalShow={handleModalShow} getcsvFileName={getcsvFileName} siteId={siteId} deviceStatus={deviceStatus} />
      </div>
    </div>
  )
}

export default DashboardTodaysAlertStatus